var map = {
	"../basket/basket.module": [
		"./src/app/basket/basket.module.ts",
		"default~basket-basket-module~builder-builder-module~checkout-checkout-module~orders-order-order-modu~f1bdedaf",
		"default~basket-basket-module~checkout-checkout-module~orders-order-order-module~orders-orders-module~ef601677",
		"common",
		"basket-basket-module"
	],
	"../builder/builder.module": [
		"./src/app/builder/builder.module.ts",
		"default~basket-basket-module~builder-builder-module~checkout-checkout-module~orders-order-order-modu~f1bdedaf",
		"common",
		"builder-builder-module"
	],
	"../more/account/account.module": [
		"./src/app/more/account/account.module.ts",
		"more-account-account-module"
	],
	"../more/more.module": [
		"./src/app/more/more.module.ts",
		"more-more-module"
	],
	"../orders/order/order.module": [
		"./src/app/orders/order/order.module.ts",
		"default~basket-basket-module~builder-builder-module~checkout-checkout-module~orders-order-order-modu~f1bdedaf",
		"default~basket-basket-module~checkout-checkout-module~orders-order-order-module~orders-orders-module~ef601677",
		"common",
		"orders-order-order-module"
	],
	"../orders/orders.module": [
		"./src/app/orders/orders.module.ts",
		"default~basket-basket-module~builder-builder-module~checkout-checkout-module~orders-order-order-modu~f1bdedaf",
		"default~basket-basket-module~checkout-checkout-module~orders-order-order-module~orders-orders-module~ef601677",
		"common",
		"orders-orders-module"
	],
	"../product/product.module": [
		"./src/app/product/product.module.ts",
		"default~basket-basket-module~builder-builder-module~checkout-checkout-module~orders-order-order-modu~f1bdedaf",
		"common",
		"product-product-module"
	],
	"../products/products.module": [
		"./src/app/products/products.module.ts",
		"default~basket-basket-module~builder-builder-module~checkout-checkout-module~orders-order-order-modu~f1bdedaf",
		"default~basket-basket-module~checkout-checkout-module~orders-order-order-module~orders-orders-module~ef601677",
		"common",
		"products-products-module"
	],
	"../storeinfo/storeinfo.module": [
		"./src/app/storeinfo/storeinfo.module.ts",
		"storeinfo-storeinfo-module"
	],
	"../stores/stores.module": [
		"./src/app/stores/stores.module.ts",
		"default~basket-basket-module~builder-builder-module~checkout-checkout-module~orders-order-order-modu~f1bdedaf",
		"common",
		"stores-stores-module"
	],
	"./checkout/checkout.module": [
		"./src/app/checkout/checkout.module.ts",
		"default~basket-basket-module~builder-builder-module~checkout-checkout-module~orders-order-order-modu~f1bdedaf",
		"default~basket-basket-module~checkout-checkout-module~orders-order-order-module~orders-orders-module~ef601677",
		"common",
		"checkout-checkout-module"
	],
	"./tabs/tabs.module": [
		"./src/app/tabs/tabs.module.ts",
		"default~basket-basket-module~builder-builder-module~checkout-checkout-module~orders-order-order-modu~f1bdedaf",
		"common",
		"tabs-tabs-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;